/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Disclosure } from '@headlessui/react';
import { MinusCircleIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

const PamInquiryCard = ({
  children,
  header,
  footer,
  className = '',
  defaultOpen = false,
  onClickOpen = () => {},
  disclosureButton = '',
}) => {
  const cn = classNames(
    '@container flex flex-col rounded-lg border border-slate-200 shadow-md',
    className,
  );
  const { t } = useTranslation('components');

  return (
    <div className={cn}>
      {header}
      <Disclosure defaultOpen={defaultOpen}>
        {({ open }) => (
          <>
            <Disclosure.Button
              className="flex w-full items-center justify-between space-x-3 p-3 bg-white"
              onClick={!open ? onClickOpen : undefined}
            >
              {disclosureButton || (
                <>
                  <span className="text-left text-lg font-semibold">
                    {t('PamInquiry.detailsHeader')}
                  </span>
                  <span className="flex items-center text-blue-500">
                    {open ? (
                      <MinusCircleIcon className="h-8 w-8" />
                    ) : (
                      <PlusCircleIcon className="h-8 w-8" />
                    )}
                  </span>
                </>
              )}
            </Disclosure.Button>
            <Disclosure.Panel className="flex flex-col px-3 bg-white">{children}</Disclosure.Panel>
          </>
        )}
      </Disclosure>
      {footer}
    </div>
  );
};

PamInquiryCard.propTypes = {
  children: PropTypes.any, // Using any because element or node throws errors in tsx files
  header: PropTypes.any,
  footer: PropTypes.any,
  className: PropTypes.string,
  defaultOpen: PropTypes.bool,
  onClickOpen: PropTypes.func,
  disclosureButton: PropTypes.node,
};

export default PamInquiryCard;
